import { TimePeriodFilter, TimePeriodFilterProps } from '@va/ui/design-system';

export const VisaTimePeriodFilter: React.FC<TimePeriodFilterProps> = (props) => {
  return <TimePeriodFilter {...props} />;
};
